import React, { useEffect, useState } from "react";
import { Modal } from "antd";

type SessionExpireProps = {
  onIdle: () => void;
  timeout: number;
};

const warningTime = 5 * 60 * 1000;

const SessionExpire: React.FC<SessionExpireProps> = ({
  onIdle,
  timeout,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deadline, setDeadline] = useState(Date.now() + timeout);

  useEffect(() => {
    const interval = setInterval(() => {
      const remainingTime = deadline - Date.now();

      if (remainingTime <= warningTime && !isModalOpen) {
        setIsModalOpen(true);
      }

      if (remainingTime <= 0) {
        clearInterval(interval);
        onIdle();
      }
    }, 1000);

    const resetTimer = () => {
      if (!isModalOpen) {
        setDeadline(Date.now() + timeout);
      }
    };

    const events = ["mousemove", "mousedown", "keydown", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    return () => {
      clearInterval(interval);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [onIdle, timeout, isModalOpen, deadline]);

  const handleContinue = () => {
    setIsModalOpen(false);
    setDeadline(Date.now() + timeout);
  };

  return (
    <div>
      <Modal
        title="Session Expiring Soon"
        open={isModalOpen}
        okText="Continue"
        cancelText="Logout"
        onOk={handleContinue}
        onCancel={() => {
          setIsModalOpen(false);
          onIdle();
        }}
        maskClosable={false}
      >
        <p>
          Your session will expire in 5 minutes. Do you want to extend your
          session?
        </p>
      </Modal>
    </div>
  );
};

export default SessionExpire;
